module.exports = __webpack_public_path__ + "static/img/5785_phase_function_Paper_PointsHejduk_Prediction.1c69e24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5785_phase_function_Paper_PointsHejduk_Prediction.png
// module id = V2A1
// module chunks = 0